/* @flow */
import React from 'react';
import ReactToggle from 'react-toggle';
import 'react-toggle/style.css';
import classnames from 'classnames/bind';

import { Label } from 'trustar-2.0/components';

import s from './Toggle.styl';
const cx = classnames.bind(s);

type ToggleProps = {
  'aria-label'?: string,
  'aria-labelledby'?: string,
  id?: string,
  name?: string,
  checked?: boolean,
  disabled?: boolean,
  className?: string,
  cyid?: string,
  defaultChecked?: boolean,
  label?: string,
  labelClassName?: string,
  onChange: Function,
};

// For the most part, the prop types are taken directly from react toggle source:
// https://github.com/instructure-react/react-toggle/blob/fb91f14dc6a31729275eeb8bb3ced42fd4f20a3f/index.es6.js#L14-L23
export class Toggle extends React.Component {
  props: ToggleProps;

  render() {
    const {
      className,
      disabled,
      cyid,
      label,
      labelClassName,
      id,
      ...props
    } = this.props;
    // Remove, if present, meta property from Redux Form before React complains
    if (props.meta) delete props.meta;
    return (
      <div className={cx('Toggle', { disabled }, className)}>
        {label && (
          <Label className={cx('label', labelClassName, { clickable: !!id })} for={id}>
            {label}
          </Label>
        )}
        <ReactToggle data-cy={cyid || 'toggle'} id={id} {...props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Toggle.js